import { useNavigation } from "@react-navigation/native";
import React, { FC } from "react";
import { StyleSheet, Text, View } from "react-native";
import { useSelector } from "react-redux";
import { kColors } from "src/kColors";
import { kFonts } from "src/kFonts";
import { kStyleConst } from "src/kStyle";
import { StandardButton } from "../components";
import { kRoute } from "../kRoute";

const P01_06_RevertEmail: FC = () => {
  const kNav = useNavigation();
  const isSmall = useSelector((state) => state.NavigationReducer.drawerType);

  const navigateToLogin = () => {
    kNav.navigate(kRoute.P01);
  };

  return (
    <View style={styles.P01_02_PageView}>
      <View style={isSmall === "slide" ? styles.P01_02_ContentViewSmall : styles.P01_02_ContentView}>
        <Text style={styles.P01_02_TitleText}>Revert Email</Text>
        <Text>If your email was changed incorrectly, please contact us at care@themaintab.com</Text>
        <StandardButton type="primary" text="GO TO LOGIN" onPress={navigateToLogin} />
      </View>
    </View>
  );
};

export const P01_06 = React.memo(P01_06_RevertEmail);

const styles = StyleSheet.create({
  P01_02_ContentView: {
    alignItems: "center",
    backgroundColor: kColors.white,
    borderRadius: 4 * kStyleConst.kBorderRadius,
    flex: 1,
    justifyContent: "center",
    marginHorizontal: 18 * kStyleConst.kSpacing,
    marginVertical: 10 * kStyleConst.kSpacing,
    padding: 6 * kStyleConst.kSpacing,
  },
  P01_02_ContentViewSmall: {
    PaddingBottom: 32 * kStyleConst.kSpacing,
    PaddingTop: 10 * kStyleConst.kSpacing,
    alignItems: "center",
    backgroundColor: kColors.white,
    flex: 1,
    justifyContent: "center",
    paddingHorizontal: 16 * kStyleConst.kSpacing,
  },
  P01_02_PageView: { alignItems: "stretch", backgroundColor: kColors.brandLight, flex: 1, justifyContent: "center" },
  P01_02_TitleText: {
    ...kFonts.profileHeader,
    color: kColors.black,
    marginBottom: 5 * kStyleConst.kSpacing,
    textAlign: "center",
  },
});
